// @ts-nocheck

import v4 from 'uuid/v4';

import networkActions from '../../../../actions/network';
import { BoomStateActionTypes } from '../../types/actions/boom';

export const handledActionTypes = [
  BoomStateActionTypes.CLAIM_REWARD,
  BoomStateActionTypes.FLUSH_NOTIFICATIONS,
  BoomStateActionTypes.REGISTER,
];

const BoomMiddlewareHandler = ({ store: { dispatch }, action }: HandlerProps) => {
  const { type: actionType, hooks: actionHooks } = action;

  if (handledActionTypes.indexOf(actionType) !== -1) {
    if (actionType === BoomStateActionTypes.CLAIM_REWARD) {
      const uniqId = v4();

      dispatch(
        networkActions.send({
          boom: {
            method: 'claimReward',
            id: uniqId,
            params: {
              uuid: action.payload.uuid,
            },
          },
        }),
      );
    }

    if (actionType === BoomStateActionTypes.REGISTER) {
      const uniqId = v4();
      const { onSuccess, onError } = actionHooks ?? {};

      dispatch(
        networkActions.send(
          {
            boom: {
              method: 'register',
              id: uniqId,
            },
          },
          {
            queryId: uniqId,
            hooks: {
              onSuccess,
              onError,
            },
          },
        ),
      );
    }

    if (actionType === BoomStateActionTypes.FLUSH_NOTIFICATIONS) {
      const uniqId = v4();

      dispatch(
        networkActions.send({
          boom: {
            method: 'flushNotifications',
            id: uniqId,
          },
        }),
      );
    }
  }
};

export default BoomMiddlewareHandler;
